module.exports = __webpack_public_path__ + "static/media/speaker_Siemens_DrChengFeng.ac91ff7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_Siemens_DrChengFeng.jpg
// module id = 253
// module chunks = 0